window.replyPage = 1;

$(function () {
    $('.user_reply').on('focus', function () {
        if ($('.add_reply.edit').length == 0) {
            $('.add_reply').addClass('edit');
        }
    });

    $('.user_reply').on('blur', function () {
        if ($('.add_reply.edit').length > 0 && $('.user_reply').val() == '') {
            $('.add_reply.edit').removeClass('edit');
        }
    });

    $('.add_reply').on('click', function () {
        if (!$('input[name=userid]').val()) {
            showLogin();
            return;
        }
    });

    $('.add_reply .btn_pub').on('click', function () {
        if ($('input[name=userid]').val() == '') {
            showLogin();
            return;
        }

        if ($('.user_reply').val() == '') {
            alert('请先写点什么！');
            return;
        }

        var id = $('#info_id').val();

        onReply(id, $('input[name=quote_id]').val(), $('.user_reply').val());
    });

    // $('.reply_body').on('click', function () {
    //     if ($('.top .top-login').length > 0) {
    //         showLogin();
    //     }
    // });
    //
    // $('.login_btn').on('click', function () {
    //     if ($('.top .top-login').length > 0) {
    //         showLogin();
    //         return;
    //     }
    // });

    getReply();
});

window.getReply = function () {
    var id = $('#info_id').val();
    if (!id || replyPage <= 0) {
        return;
    }

    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/content/' + id + '/root-comments?page=' + replyPage + '&size=99&sub_comment_count=99',
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data == '') {
                return;
            }
            if (data.message !== undefined) {
                alert('操作失败:' + data.message);
                return;
            }
            if (data.data === undefined) {
                alert('操作失败');
                return;
            }
            var newlist = '';
            for (var i = 0; i < data.data.length; i++) {
                var info = data.data[i];

                newlist += '<div class="reply_item">';
                if (info.author_avatar_url != null && info.author_avatar_url != '') {
                    newlist += '<a class="reply_avatar" href="' + ROOT + '/user/id/' + info.author_id + '">';
                    newlist += '<img src="' + info.author_avatar_url + '?w=52&h=52&s=3" /></a>';
                } else {
                    newlist += '<a class="reply_avatar" href="' + ROOT + '/user/id/' + info.author_id + '">';
                    newlist += '<img src="' + ROOT + '/static/images/no-avatar.png" /></a>';
                }
                newlist += '<div class="reply_right">';
                newlist += '<div class="reply_top">';
                newlist += '<div class="reply_top_left">';
                newlist += '<div class="reply_name">' + info.author_nickname + '</div>';
                newlist += '<br />';
                newlist += '<div class="reply_time">' + showTime(info.creation_time) + '</div>';
                newlist += '</div>';

                newlist += '<div class="reply_top_right">';
                newlist += '<div class="reply_sub_count" dataid="' + info.id + '">' + info.sub_comment_count + '</div>';
                newlist += '<div class="reply_like" dataid="' + info.id + '" data-attitudestate="' + info.attitude_state + '">' + info.like_count + '</div>';
                newlist += '</div>';

                newlist += '</div>';
                newlist += '<div class="reply_middle">';
                newlist += '<div class="reply_content">' + info.text + '</div>';
                newlist += '</div>';
                // newlist += '<div class="reply_bottom">';
                // newlist += '<div class="reply_button" data-value="' + info.id + '"><a>回复</a></div>';
                // if (info.sub_comment_count > 0) {
                //     newlist += '<div class="reply_sub_count" data-value="' + info.id + '">';
                //     newlist += '回复(' + info.sub_comment_count + ')';
                //     newlist += '<a class="glyphicon glyphicon-chevron-down"></a></div>';
                // } else {
                //     newlist += '<div class="reply_sub_count" data-value="' + info.id + '" disabled="disabled">';
                //     newlist += '回复(' + info.sub_comment_count + ')</div>';
                // }
                // newlist += '<div class="reply_like_button" data-value="' + info.id + '">';
                // newlist += '<div class="reply_like"><img src="' + ROOT + '/static/images/btn-like.png">';
                // newlist += '<span>' + info.like_count + '</span>';
                // newlist += '</div>';
                // newlist += '<div class="reply_dislike">';
                // newlist += '<img src="' + ROOT + '/static/images/btn-dislike.png">';
                // newlist += '<span>' + info.dislike_count + '</span>';
                // newlist += '</div>';
                // newlist += '</div>';
                // newlist += '</div>';
                newlist += '</div>';

                newlist += '<div class="reply_sub_list" data-value="' + info.id + '" page="1">';
                if (info.sub_comments && info.sub_comments.length > 0) {
                    for (var j = 0; j < info.sub_comments.length; j++) {
                        var tmp = info.sub_comments[j];

                        newlist += '<div class="reply_item">';
                        if (tmp.author_avatar_url != null && tmp.author_avatar_url != '') {
                            newlist += '<a class="reply_avatar" href="' + ROOT + '/user/id/' + tmp.author_id + '">';
                            newlist += '<img src="' + tmp.author_avatar_url + '?w=52&h=52&s=3" /></a>';
                        } else {
                            newlist += '<a class="reply_avatar" href="' + ROOT + '/user/id/' + tmp.author_id + '">';
                            newlist += '<img src="' + ROOT + '/static/images/no-avatar.png" /></a>';
                        }
                        newlist += '<div class="reply_right">';
                        newlist += '<div class="reply_top">';
                        newlist += '<div class="reply_top_left">';
                        newlist += '<div class="reply_name">' + tmp.author_nickname + '</div>';
                        newlist += '<br />';
                        newlist += '<div class="reply_time">' + showTime(tmp.creation_time) + '</div>';
                        newlist += '</div>';

                        newlist += '<div class="reply_top_right">';
                        newlist += '<div class="reply_sub_count" dataid="' + tmp.id + '"></div>';
                        newlist += '<div class="reply_like" dataid="' + tmp.id + '" data-attitudestate="' + info.attitude_state + '">' + tmp.like_count + '</div>';
                        newlist += '</div>';

                        newlist += '</div>';
                        newlist += '<div class="reply_middle">';
                        newlist += '<div class="reply_content">';
                        if (tmp.ref_comment && tmp.ref_comment.id != info.id) {
                            newlist += '@<span>' + tmp.ref_comment.author_nickname + ':</span>';
                        }
                        newlist += tmp.text + '</div>';
                        newlist += '</div>';
                        newlist += '</div>';
                    }
                }
                newlist += '</div>';
                newlist += '</div>';
                newlist += '<div class="dividing-line"></div>';
            }

            if (replyPage == 1) {
                $('.reply_list').html(newlist);
            } else {
                $('.reply_list').append(newlist);
            }

            replyEventBinding();

            if (data.total == 0) {
                $('.reply .no-reply').css('display', 'block');
                $('.reply .more').css('display', 'none');
            } else if (data.total <= replyPage * 20) {
                $('.reply .no-reply').css('display', 'none');
                $('.reply .more').css('display', 'block');
                $('.reply .more').addClass('no-more');
                replyPage = 0;
            } else {
                replyPage++;
            }

            $('.reply_sub_count').on('click', function () {
                var id = $(this).attr('dataid');
                if (!id) return;
                if ($('.reply_quote_btn[dataid=' + id + ']').length > 0) {
                    $('.reply_quote_btn[dataid=' + id + ']').parents('.reply_quote').remove();
                    return;
                }
                // if ($(this).hasClass('open')) {
                //     $(this).removeClass('open');
                //     $(this).children('.glyphicon-chevron-up').addClass('glyphicon-chevron-down');
                //     $(this).children('.glyphicon-chevron-up').removeClass('glyphicon-chevron-up');
                //
                //     var id = $(this).attr('data-value');
                //     $('.reply_sub_list[data-value=' + id + ']').css('display', 'none');
                // } else {
                //     $(this).addClass('open');
                //     $(this).children('.glyphicon-chevron-down').addClass('glyphicon-chevron-up');
                //     $(this).children('.glyphicon-chevron-down').removeClass('glyphicon-chevron-down');
                //
                //     var id = $(this).attr('data-value');
                //     $('.reply_sub_list[data-value=' + id + ']').css('display', 'block');
                //     getSubReply(id);
                // }
                var html = '<div class="reply_quote">';
                html += '<textarea class="reply_quote_body"></textarea>';
                html += '<div class="reply_quote_btn2"><div class="reply_quote_btn" dataid="' + id + '">发表</div></div>';
                html += '</div>';

                $(this).parents('.reply_right').append(html);

                $('.reply_quote_btn').off('click');
                $('.reply_quote_btn').on('click', function () {
                    var id = $('#info_id').val();
                    var qid = $(this).attr('dataid');
                    var text = $(this).parents('.reply_quote').children('.reply_quote_body').val();
                    onReply(id, qid, text);
                });
            });
        },
        error: function (data) {
            console.log(data);
            if (data.message !== undefined) {
                alert('获取评论列表失败:' + data.message);
            } else {
                alert('获取评论列表失败');
            }
        }
    });
};

window.getSubReply = function (id) {
    var page = $('.reply_sub_list[data-value=' + id + ']').attr('page');
    if (page == 0) {
        return;
    }

    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/content/' + id + '/sub-comments?page=' + page + '&size=10',
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data !== undefined && data.message !== undefined) {
                console.log(data);
                return;
            }

            var newlist = '';
            for (var i = 0; i < data.data.length; i++) {
                var info = data.data[i];

                newlist += '<div class="reply_sub_item">';
                if (info.author_avatar_url != null && info.author_avatar_url != '') {
                    newlist += '<a class="reply_avatar" href="' + ROOT + '/user/id/' + info.author_id + '">';
                    newlist += '<img src="' + info.author_avatar_url + '?w=52&h=52&s=3" /></a>';
                } else {
                    newlist += '<a class="reply_avatar" href="' + ROOT + '/user/id/' + info.author_id + '">';
                    newlist += '<img src="' + ROOT + '/static/images/no-avatar.png" /></a>';
                }
                newlist += '<div class="reply_right">';

                newlist += '<div class="reply_top">';
                newlist += '<div class="reply_name">' + info.author_nickname + '</div>';
                newlist += '<div class="reply_time"></div>';
                newlist += '</div>';

                newlist += '<div class="reply_middle">';
                newlist += '<div class="reply_content">' + info.text + '</div>';
                newlist += '</div>';

                newlist += '<div class="reply_bottom">';
                newlist += '<div class="reply_button" data-value="' + info.id + '"><a>回复</a></div>';
                newlist += '<div class="reply_like_button" data-value="' + info.id + '">';
                newlist += '<div class="reply_like"><img src="' + ROOT + '/static/images/btn-like.png">';
                newlist += '<span>' + info.like_count + '</span>';
                newlist += '</div>';
                newlist += '<div class="reply_dislike"><img src="' + ROOT + '/static/images/btn-dislike.png">';
                newlist += '<span>' + info.dislike_count + '</span>';
                newlist += '</div>';
                newlist += '</div>';

                newlist += '</div>';
                newlist += '</div>';
                newlist += '</div>';
            }

            if (data.total <= 10 * page) {
                $('.reply_sub_list[data-value=' + id + ']').attr('page', 0);
            } else {
                $('.reply_sub_list[data-value=' + id + ']').attr('page', page + 1);
                newlist += '<a class="reply_load_more" data-value="' + id + '">查看更多回复</a>';
            }

            $('.reply_load_more[data-value=' + id + ']').remove();
            $('.reply_sub_list[data-value=' + id + ']').append(newlist);

            replyEventBinding();
        },
        error: function (data) {
            console.log(data);
        }
    });
};

window.replyEventBinding = function () {
    $('.reply_button').on('click', function () {
        if ($('.top .top-login').length > 0) {
            showLogin();
            return;
        }

        var id = $(this).attr('data-value');
        $('input[name=quote_id]').val(id);
        $('.user_reply').focus();
    });

    $('.reply_like').on('click', function () {
        if ($('.top .top-login').length > 0) {
            showLogin();
            return;
        }

        var p = $(this);

        var id = p.attr('dataid');
        var state = p.data('attitudestate');
        if (state === 1) {
            $.ajax({
                type: 'post',
                async: false,
                url: ROOT + '/comments/' + id + '/cancel-attitude',
                data: null,
                contentType: 'application/json',
                dataType: 'json',
                success: function (data) {
                    if (data != '') {
                        p.find('span').text(data);
                    } else {
                        p.data('attitudestate', 0);
                        var n = p.text();
                        p.text(Number(n) - 1);
                    }
                },
                error: function (data) {
                    console.log(data);
                }
            });
        } else {
            $.ajax({
                type: 'post',
                async: false,
                url: ROOT + '/comments/' + id + '/like',
                data: null,
                contentType: 'application/json',
                dataType: 'json',
                success: function (data) {
                    if (data != '') {
                        p.find('span').text(data);
                    } else {
                        p.data('attitudestate', 1);
                        var n = p.text();
                        p.text(Number(n) + 1);
                    }
                },
                error: function (data) {
                    console.log(data);
                }
            });
        }
    });

    $('.reply_dislike').on('click', function () {
        if ($('.top .top-login').length > 0) {
            showLogin();
            return;
        }

        var p = $(this);
        if (p.hasClass('clicked')) {
            return;
        }
        var id = p.parent().attr('data-value');
        $.ajax({
            type: 'post',
            async: false,
            url: ROOT + '/comments/' + id + '/dislike',
            data: null,
            contentType: 'application/json',
            dataType: 'json',
            success: function (data) {
                if (data != '') {
                    p.find('span').text(data);
                } else {
                    var n = p.find('span').text();
                    p.find('span').text(Number(n) + 1);
                }
                p.addClass('clicked');
            },
            error: function (data) {
                console.log(data);
            }
        });
    });

    $('.reply_load_more').on('click', function () {
        var id = $(this).attr('data-value');
        getSubReply(id);
    });
};

window.onReply = function (id, qid, text) {
    if ($('input[name=userid]').val() == '') {
        showLogin();
        return;
    }

    var data = {
        'ref_comment_id': qid,
        'text': text
    };

    $.ajax({
        type: 'post',
        async: false,
        url: ROOT + '/content/' + id + '/comments',
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data !== undefined && data.message !== undefined) {
                alert('发表回复失败:' + data.message);
                return;
            } else {
                console.log(data);
                alert('发表回复成功！');
                location.reload();
            }
        },
        error: function (data) {
            if (data.message !== undefined) {
                console.log(data.message);
                alert('发表失败:' + data.message);
            } else {
                console.log(data);
                alert('发表失败');
            }
        }
    });
};

function showTime(time) {
    try {
        if (!time) {
            return '';
        }

        var dt = (new Date().getTime()) / 1000;
        var t = parseInt((dt - time) / 60);
        if (t < 60) {
            return t + '分钟前';
        }
        t = parseInt(t / 60);
        if (t < 24) {
            return t + '小时前';
        }
        return dateFormat(new Date(parseInt(time) * 1000), 'MM-dd hh:mm');
    } catch (e) {
        return '';
    }
}

$('.user_reply').bind('keyup', function () {
    var txtChange = $('.user_reply').val();
    if (txtChange.length >= 201) {
        return;
    }
    $('.reply-text-num-span').text(txtChange.length);
});